import { Text, View } from '@react-pdf/renderer';
import React, { FC } from 'react';
import { IntlFormatters } from '@formatjs/intl/src/types';

import messages from '../messages';
import { styles } from './styles';

type ResumePdfSkillsProps = {
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
};

export const ResumePdfSkills: FC<ResumePdfSkillsProps> = ({ profile, formatMessage }) => {
  const renderedSkills = profile.skills.principalSkills
    .reduce((acc, { skills }) => [...acc, ...skills], [] as AH$ProfileSkill[])
    .map(({ skill }) => skill);

  return renderedSkills.length ? (
    <View style={styles.section}>
      <Text style={[styles.subheading, styles.bold, styles.spaceBottomBig]}>
        {formatMessage(messages.relevantSkills)}
      </Text>
      <View
        style={{
          display: 'flex',
          rowGap: 8,
          columnGap: 2,
          flexWrap: 'wrap',
          flexDirection: 'row',
        }}
      >
        <Text style={styles.text}>{renderedSkills.join('   ')}</Text>
      </View>
    </View>
  ) : null;
};
